import styles from './CadastroCliente.module.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../shared/form/Input';

function CadastroCliente() {
  const nomeGoogle = localStorage.getItem("nome_usuario_google") || "";
  const emailGoogle = localStorage.getItem("email_google") || "";

  // Contexto do estabelecimento visitado antes do cadastro (setado em ItensEstabelecimento):
  // '' = restaurante (sem universidade), null = nenhum contexto conhecido, outro = id da universidade
  const contextoUniversidade = localStorage.getItem("estabelecimento_contexto_universidade");
  const isRestaurante = contextoUniversidade === '';

  const [nome, setNome] = useState(nomeGoogle);
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState(emailGoogle);
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [idUniversidade, setIdUniversidade] = useState(isRestaurante ? '' : (contextoUniversidade || ''));
  const [codigo, setCodigo] = useState('');
  const [step, setStep] = useState(1); // 1: preencher dados, 2: verificar código
  const [error, setError] = useState('');
  const [senhaForte, setSenhaForte] = useState({ valida: false, mensagem: '' });
  const [universidades, setUniversidades] = useState([]);

  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  // Buscar universidades ao carregar o componente
  useEffect(() => {
    const fetchUniversidades = async () => {
      try {
        const response = await fetch(`${API_URL}/universidades`);
        const data = await response.json();
        console.log('📥 Universidades recebidas:', data);
        // Garantir que seja um array
        if (Array.isArray(data)) {
          setUniversidades(data);
        } else {
          console.error('❌ Dados não são um array:', data);
          setUniversidades([]);
        }
      } catch (error) {
        console.error("Erro ao buscar universidades:", error);
        setUniversidades([]);
      }
    };
    fetchUniversidades();
  }, [API_URL]);

  // Validar força da senha em tempo real
  const validarSenha = (senha) => {
    if (senha.length < 8) {
      return { valida: false, mensagem: 'A senha deve ter no mínimo 8 caracteres' };
    }
    if (!/[A-Z]/.test(senha)) {
      return { valida: false, mensagem: 'A senha deve conter pelo menos uma letra maiúscula' };
    }
    if (!/[a-z]/.test(senha)) {
      return { valida: false, mensagem: 'A senha deve conter pelo menos uma letra minúscula' };
    }
    if (!/[0-9]/.test(senha)) {
      return { valida: false, mensagem: 'A senha deve conter pelo menos um número' };
    }
    return { valida: true, mensagem: 'Senha forte!' };
  };

  const handleSenhaChange = (e) => {
    const novaSenha = e.target.value;
    setSenha(novaSenha);
    setSenhaForte(validarSenha(novaSenha));
  };

  // 1️⃣ Envia código
  const enviarCodigo = async () => {
    console.log('🔍 Dados do formulário:', { nome, telefone, email, senha, idUniversidade });
    console.log('🔍 Senha forte:', senhaForte);

    if (!nome || !telefone || !email || !senha || !confirmarSenha || (!isRestaurante && !idUniversidade)) {
      console.log('❌ Campos faltando');
      setError('Preencha todos os campos.');
      return;
    }

    // Validar força da senha
    if (!senhaForte.valida) {
      console.log('❌ Senha não é forte');
      setError(senhaForte.mensagem);
      return;
    }

    if (senha !== confirmarSenha) {
      console.log('❌ Senhas não coincidem');
      setError('As senhas não coincidem.');
      return;
    }

    try {
      console.log('📤 Enviando requisição para:', `${API_URL}/cliente/enviar-codigo`);
      console.log('📤 Dados enviados:', { nome, telefone, email, senha, idUniversidade });

      const response = await fetch(`${API_URL}/cliente/enviar-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome, telefone, email, senha, idUniversidade })
      });

      console.log('📥 Status da resposta:', response.status);
      console.log('📥 Response OK?', response.ok);

      const data = await response.json();
      console.log('📥 Resposta do servidor:', data);

      if (response.ok) {
        console.log('✅ Código enviado com sucesso');
        alert('Código enviado para seu email!');
        setStep(2);
        setError('');
      } else {
        console.log('❌ Erro na resposta:', data.error);
        setError(data.error || "Erro ao enviar código.");
      }
    } catch (err) {
      console.error('❌ Erro na requisição:', err);
      setError("Erro na requisição. Tente novamente: " + err.message);
    }
  };

  // 2️⃣ Confirma código e cria cliente
  const confirmarCodigo = async () => {
    if (!codigo) {
      setError("Digite o código enviado por e-mail.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/cliente/verificar-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, codigo, idEstabelecimento: null })
      });

      const data = await response.json();

      if (response.ok) {
        // Salvar todos os dados do cliente no localStorage
        localStorage.setItem('nome_usuario', data.nome);
        localStorage.setItem('id_cliente', data.id_cliente);
        localStorage.setItem('tipo_usuario', data.tipo);
        if (data.id_universidade) {
          localStorage.setItem('id_universidade', data.id_universidade);
        } else {
          localStorage.removeItem('id_universidade');
        }
        if (data.nomeUniversidade) {
          localStorage.setItem('nomeUniversidade', data.nomeUniversidade);
        } else {
          localStorage.removeItem('nomeUniversidade');
        }
        if (data.token) {
          localStorage.setItem('token', data.token);
        }
        alert('Cliente cadastrado com sucesso!');
        // Se veio de um checkout interrompido (ex: escaneou QR sem estar logado), volta pro carrinho
        const redirectAfterLogin = localStorage.getItem('redirect_after_login');
        localStorage.removeItem('redirect_after_login');
        navigate(redirectAfterLogin || '/homecliente');
      } else {
        setError(data.error || "Código inválido.");
      }
    } catch (err) {
      console.error(err);
      setError("Erro ao verificar código. Tente novamente.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    enviarCodigo();
  };

  return (
    <main className={styles.secaoprincipal}>
      {step === 1 && (
        <header className={styles.cabecalho_page}>
          <h2>{isRestaurante ? "Bem-vindo ao SpeedOrder!" : "Bem-vindo ao UniEat!"}</h2>
          <p>Crie sua conta gratuitamente e comece a fazer seus pedidos de forma rápida e prática.</p>
        </header>
      )}

      {step === 1 && (
        <form onSubmit={handleSubmit} className={styles.formulario}>
          <Input
            type="text"
            text="Nome Completo"
            placeholder="Digite seu nome completo"
            handleOnChange={e => setNome(e.target.value)}
            value={nome}
            disabled={!!nomeGoogle}
          />
          <Input
            type="text"
            text="Telefone"
            placeholder="(11) 98765-4321"
            handleOnChange={e => setTelefone(e.target.value)}
            value={telefone}
          />
          <Input
            type="email"
            text={isRestaurante ? "Email" : "Email Institucional"}
            placeholder={isRestaurante ? "seu@email.com" : "seu.email@universidade.edu.br"}
            handleOnChange={e => setEmail(e.target.value)}
            value={email}
            disabled={!!emailGoogle}
          />
          {!isRestaurante && (
            <div className={styles.itensform}>
              <select
                value={idUniversidade}
                onChange={e => setIdUniversidade(e.target.value)}
                required
              >
                <option value="" disabled>Selecione sua universidade</option>
                {Array.isArray(universidades) && universidades.length > 0 ? (
                  universidades.map(univ => (
                    <option key={univ.id_universidade} value={univ.id_universidade}>
                      {univ.nome}
                    </option>
                  ))
                ) : (
                  <option disabled>Carregando universidades...</option>
                )}
              </select>
            </div>
          )}
          <br />
          <Input
            type="password"
            text="Crie uma Senha Segura"
            placeholder="Mínimo 8 caracteres (letras maiúsculas, minúsculas e números)"
            handleOnChange={handleSenhaChange}
            value={senha}
          />
          {senha && (
            <p style={{
              fontSize: '0.9rem',
              color: senhaForte.valida ? '#28a745' : '#ff9800',
              marginTop: '-10px',
              marginBottom: '10px',
              fontWeight: '500'
            }}>
              {senhaForte.valida ? '✓ ' : '⚠ '}{senhaForte.mensagem}
            </p>
          )}
          <Input
            type="password"
            text="Confirme sua Senha"
            placeholder="Confirme a senha"
            handleOnChange={e => setConfirmarSenha(e.target.value)}
            value={confirmarSenha}
          />
          {confirmarSenha && senha !== confirmarSenha && (
            <p style={{
              fontSize: '0.9rem',
              color: '#ff9800',
              marginTop: '-10px',
              marginBottom: '10px',
              fontWeight: '500'
            }}>
              ⚠ As senhas não coincidem
            </p>
          )}
          {confirmarSenha && senha === confirmarSenha && senha.length > 0 && (
            <p style={{
              fontSize: '0.9rem',
              color: '#28a745',
              marginTop: '-10px',
              marginBottom: '10px',
              fontWeight: '500'
            }}>
              ✓ Senhas coincidem
            </p>
          )}
         
          {error && <p className={styles.error}>{error}</p>}
          <button type="submit" className={styles.btnCadastrar}>Criar Minha Conta</button>
          <p className={styles.termos}>
            Ao criar sua conta, você concorda com nossos termos de uso e política de privacidade.
          </p>
        </form>
      )}

      {step === 2 && (
        <form className={styles.form_cadastro_cliente} onSubmit={e => { e.preventDefault(); confirmarCodigo(); }}>
          <div className={styles.verificacao_header}>
            <h3>Verifique seu Email</h3>
            <p>Enviamos um código de verificação para:</p>
            <p className={styles.email_destaque}>{email}</p>
            <p className={styles.instrucao}>Digite o código abaixo para concluir seu cadastro:</p>
          </div>
          <Input
            type="text"
            text="Código de Verificação"
            placeholder="000000"
            handleOnChange={e => setCodigo(e.target.value)}
            value={codigo}
          />
          {error && <p className={styles.error}>{error}</p>}
          <button type="submit" className={styles.btn}>Confirmar e Continuar</button>
          <p className={styles.reenviar}>
            Não recebeu o código? <span onClick={enviarCodigo} className={styles.plink}> <br/> Reenviar código</span>
          </p>
        </form>
      )}
    </main>
  );
}

export default CadastroCliente;
